import { forwardRef } from "react";
import "../../styles/Modal/PaymentModal.css";

const PaymentModal = forwardRef(({ isOpen, onClose, handleSubmit }, ref) => {
  if (!isOpen) return null;
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Unlock Your Startup’s Growth Potential</h2>
        <p>
          Gain valuable insights and expert recommendations to accelerate your
          business success.
        </p>
        <div>Benefits</div>
        <ul>
          <li>
            <b>Actionable Insights:</b> Get a clear analysis of your startup’s
            strengths, gaps, and growth opportunities.
          </li>
          <li>
            <b>Tailored Strategies:</b> Receive expert-backed recommendations
            designed specifically for your business stage.
          </li>
          <li>
            <b>Faster Scaling:</b> Unlock proven frameworks to accelerate
            execution and maximize results.
          </li>
        </ul>
        <p style={{ textAlign: "left" }}>
          <b>Amount:</b> Only at 50,000/-
        </p>

        <div className="modal-buttons">
          <button ref={ref} onClick={handleSubmit} className="payment-btn btn-success">
            Pay To Get Report
          </button>
          <button onClick={onClose} className="payment-btn btn-danger">
            <img src="/close.svg" alt="close-icon" height={25} width={25} />
          </button>
        </div>
      </div>
    </div>
  );
});

export default PaymentModal;
